export const environment = {
  production: false,
  envName: 'development',
  version: '1.5.0',
  buildDate: '2026-08-20',

  blogUrl: 'https://infraon.io/blog/wp-json/wp/v2/posts?_embed&per_page=10',
  apiBaseUrl: 'https://portal.api.mono.infraontech.com/ux/org',
  apis: {
    getKey: '/getkey',
    verifyorg: '/verifyorg',
    crmregister: '/crmregister/',
    register: '/register/',
    registerStatus: '/register/status/',
  },
  chatApiBaseUrl: 'https://49.249.132.227/api',
  chatWsBaseUrl: 'wss://49.249.132.227/ws',
  currencyRates: 'https://api.frankfurter.app/latest?from=USD&to=',
  recaptchaKey: '6Le-Z-ssAAAAAGyji1nzwbZSk2k2K9FGw4DwV8bx',
};
